export default __webpack_public_path__ + "static/Sandra.01-a4155d2933d056e797a2296688783205.jpg";